export default "/_next/static/images/draftsMembership-7ca821c7423b728e367fa181eed88e50.png";